import(/* webpackMode: "eager" */ "/app/app/[locale]/(public)/privacy-policy/page.tsx");
